/**
 * Embedded mode: the iOS app opens course lessons in a web view with `?embed=1`. In that mode the
 * page is a lesson, not the website: no top navigation, no optional popups (announcements, PWA
 * install, username prompt, coach marks). The flag sticks for the tab so in-page navigation keeps it.
 */
const KEY = "efa-embed";
let cached: boolean | null = null;
export function isEmbedded(): boolean {
  if (cached !== null) return cached;
  try {
    const q = new URLSearchParams(window.location.search).get("embed");
    if (q === "1") { sessionStorage.setItem(KEY, "1"); cached = true; return true; }
    if (q === "0") { sessionStorage.removeItem(KEY); cached = false; return false; }
    cached = sessionStorage.getItem(KEY) === "1";
  } catch { cached = false; }
  return cached;
}
